import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./CustomModal.css";
import { NavLink } from "react-router-dom";

const ActionRequiredValidationModal = ({ show, handleConfirm }) => {
  const [confirmClicked, setConfirmClicked] = useState(false);

  return (
    <Modal className="custom-modal actionreqmodaltext" centered show={show}>
      <Modal.Body className="">
        {/* <p className="title">
          Please Complete the <NavLink to="/my-inventory/new_product_request/action_req"><strong>Actions Pending</strong></NavLink> for{" "}
          <NavLink to="/my-inventory/new_product_request/action_req"><strong>Product Approval</strong></NavLink>.
        </p>
        <p className="red-title">
          Note : Untill you complete the pending actions, you will not be able
          to process any orders.
        </p> */}
        <p className="red-title text-center">
          Inventory Update! Action Required 
        </p>
          <p className="title text-center">
            New Product(s) are pending for your approval.<br />
            Kindly approve/reject it to have full access to seller panel.
          {/* Please Complete the <NavLink to="/my-inventory/ationRequired"><strong>Actions Pending</strong></NavLink> for{" "}
          <NavLink to="/my-inventory/ationRequired"><strong>Product Approval</strong></NavLink>. */}
        </p>

        <div className="text-center">
          <NavLink to="/my-inventory/new_product_request/action_req">
            <Button className="">
              Complete Now
            </Button>
          </NavLink>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActionRequiredValidationModal;
